export default "__VITE_ASSET__O$oO$lU$__"